import APIClient from '@/shared/http/clients/api'

const resourceName = 'authenticate'
const APIAccess = process.env.APIBaseURLCore

const SignIn = (data = {}, config = {}) => APIClient.post(`${APIAccess}/${resourceName}`, data, config)
const SignOut = (data = {}, config = {}) => APIClient.post(`${resourceName}/signOut`, data, config)

const AuthRepository = {
  SignIn,
  SignOut
}

export default AuthRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/access/auth.js